exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-hint-list__item--found {\n    text-decoration: line-through;\n}\n", ""]);

// exports
